import { Typography } from "@mui/material";
import React, { ReactNode } from "react";
import styled from "styled-components";
import { ModalType } from "./SubscriptionModalContext";

// export const subscriptionsContents = (modal: ModalType): ReactNode => ({
//     "DISCUSSION": <DiscussionContent />,
//     "UPVOTING": <UpvotingContent />,
//     "DOWNVOTING": <DownvotingContent />,
//     "UPVOTING_COMMENT": <UpvotingCommentContent />,
//     "DOWNVOTING_COMMENT": <DownvotingCommentContent />,
//     "UPVOTING_REPLY": <UpvotingReplyContent />,
//     "DOWNVOTING_REPLY": <DownvotingReplyContent />,
//     "COMMENTS": <CommentsContent />,
//     "REPLY": <ReplyContent />,
//     "SHARE": <ShareContent />,
//     "BOOKMARK": <BookmarkContent />,
//     "FOLLOW": <FollowContent />,
//     "REPORT": <ReportContent />,
//     "REPORT_COMMENT": <ReportCommentContent />,
//     "REPORT_REPLY": <ReportReplyContent />,
//     "BLOCK": <BlockContent />,
//     "JOIN": <JoinContent />,
//     "": <DiscussionContent />
// })[modal || ""];

export const subscriptionsContents = (modal?: ModalType): ReactNode => <DiscussionContent />

const DiscussionContent = () => (
  <>
    <IconContainer>
      <Image src={require("assets/view_only.webp")} />
    </IconContainer>
    <Heading>More engagement requires upgrading your level</Heading>
    <Description>Your plan restricts you to use the full potential of StockEdge Social. Upgrade your plan to benefit from the power of this exclusive community.</Description>
  </>
)

// const DiscussionContent = () => (
//     <>
//         <Heading>Upgrade to Unlock all features</Heading>
//         <Description>Upgrade to monthly, quarterly or yearly plan to unlock all features and use the full potential of StockEdge Social.</Description>
//     </>
// )

// const DiscussionContent = () => (
//     <>
//         <Heading>Start Discussing stock ideas or post your stock queries</Heading>
//         <Description>Subscribe to StockEdge Club to start a discussion with other members.</Description>
//     </>
// )

// const JoinContent = () => (
//     <>
//         <Heading>Follow subject matter specific discussions by joining clubs</Heading>
//         <Description>Subscribe to StockEdge Club to follow ideas of other members on specified subject matter.</Description>
//     </>
// )

// const UpvotingContent = () => (
//     <>
//         <IconContainer>
//             <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                 <path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3" />
//             </svg>
//         </IconContainer>
//         <Heading>Show Support by Upvoting a post</Heading>
//         <Description>Subscribe to StockEdge Club to upvote and show support to someone’s post</Description>
//     </>
// )

// const DownvotingContent = () => (
//     <>
//         <IconContainer>
//             <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                 <path d="M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17" />
//             </svg>
//         </IconContainer>
//         <Heading>Express disagreement by downvoting</Heading>
//         <Description>Subscribe to StockEdge Club to downvote a post.</Description>
//     </>
// )

// const UpvotingCommentContent = () => (
//     <>
//         <IconContainer>
//             <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                 <path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3" />
//             </svg>
//         </IconContainer>
//         <Heading>Show Support by Upvoting a comment</Heading>
//         <Description>Subscribe to StockEdge Club to upvote and show support to someone’s comment</Description>
//     </>
// )

// const DownvotingCommentContent = () => (
//     <>
//         <IconContainer>
//             <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                 <path d="M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17" />
//             </svg>
//         </IconContainer>
//         <Heading>Express disagreement by downvoting</Heading>
//         <Description>Subscribe to StockEdge Club to downvote a comment.</Description>
//     </>
// )

// const UpvotingReplyContent = () => (
//     <>
//         <IconContainer>
//             <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                 <path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3" />
//             </svg>
//         </IconContainer>
//         <Heading>Show Support by Upvoting a reply</Heading>
//         <Description>Subscribe to StockEdge Club to upvote and show support to someone’s reply</Description>
//     </>
// )

// const DownvotingReplyContent = () => (
//     <>
//         <IconContainer>
//             <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                 <path d="M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17" />
//             </svg>
//         </IconContainer>
//         <Heading>Express disagreement by downvoting</Heading>
//         <Description>Subscribe to StockEdge Club to downvote a reply.</Description>
//     </>
// )

// const CommentsContent = () => (
//     <>
//         <IconContainer>
//             <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                 <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
//             </svg>
//         </IconContainer>
//         <Heading>Express your views by posting comments</Heading>
//         <Description>Subscribe to StockEdge Club to express your views on someone’s post.</Description>
//     </>
// )

// const ReplyContent = () => (
//     <>
//         <IconContainer>
//             <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                 <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
//             </svg>
//         </IconContainer>
//         <Heading>Express your views by posting replies</Heading>
//         <Description>Subscribe to StockEdge Club to express your views on someone’s comment.</Description>
//     </>
// )

// const ShareContent = () => (
//     <>
//         <IconContainer>
//             <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                 <circle cx="18" cy="5" r="3" />
//                 <circle cx="6" cy="12" r="3" />
//                 <circle cx="18" cy="19" r="3" />
//                 <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
//                 <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
//             </svg>
//         </IconContainer>
//         <Heading>Share with your followers to spread the information</Heading>
//         <Description>Subscribe to StockEdge Club to share the post with your followers.</Description>
//     </>
// )

// const BookmarkContent = () => (
//     <>
//         <IconContainer>
//             <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                 <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z" />
//             </svg>
//         </IconContainer>
//         <Heading>Bookmark to revisit and continue where you left off.</Heading>
//         <Description>Subscribe to StockEdge Club to bookmark posts so that you don’t miss out on important information.</Description>
//     </>
// )

// const FollowContent = () => (
//     <>
//         <IconContainer>
//             <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                 <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
//                 <circle cx="9" cy="7" r="4" />
//                 <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
//                 <path d="M16 3.13a4 4 0 0 1 0 7.75" />
//             </svg>
//         </IconContainer>
//         <Heading>Follow to be updated with what they share</Heading>
//         <Description>Subscribe to StockEdge Club to follow someone for their views, and guidance. </Description>
//     </>
// )

// const ReportContent = () => (
//     <>
//         <IconContainer>
//             <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                 <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z" />
//                 <line x1="4" y1="22" x2="4" y2="15" />
//             </svg>
//         </IconContainer>
//         <Heading>Report a post for wrong or misleading information</Heading>
//         <Description>Subscribe to StockEdge Club to report a post if you feel that it’s harmful, wrong or misleading.</Description>
//     </>
// )

// const ReportCommentContent = () => (
//     <>
//         <IconContainer>
//             <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                 <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z" />
//                 <line x1="4" y1="22" x2="4" y2="15" />
//             </svg>
//         </IconContainer>
//         <Heading>Report a comment for abusive, or misleading reply on the post</Heading>
//         <Description>Subscribe to StockEdge Club to report a comment if you feel that it’s harmful, abusive, misleading or aiming to bully a member.</Description>
//     </>
// )

// const ReportReplyContent = () => (
//     <>
//         <IconContainer>
//             <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                 <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z" />
//                 <line x1="4" y1="22" x2="4" y2="15" />
//             </svg>
//         </IconContainer>
//         <Heading>Report a reply for abusive, or misleading reply on the post</Heading>
//         <Description>Subscribe to StockEdge Club to report a reply if you feel that it’s harmful, abusive, misleading or aiming to bully a member.</Description>
//     </>
// )

// const BlockContent = () => (
//     <>
//         <IconContainer>
//             <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                 <circle cx="12" cy="12" r="10" />
//                 <line x1="12" y1="8" x2="12" y2="12" />
//                 <line x1="12" y1="16" x2="12.01" y2="16" />
//             </svg>
//         </IconContainer>
//         <Heading>Block User</Heading>
//         <Description>Subscribe to StockEdge Club to block someone from following you.</Description>
//     </>
// )

const Heading = styled(Typography)`
  && {
    font-family: Roboto;
    font-style: normal;
    font-weight: 600;
    font-size: 1.1125rem;
    line-height: 1.5rem;
    text-align: center;
    color: #1F4386 !important;
    margin: 5px 0 32px 0;
  }
`;

const Description = styled(Typography)`
  && {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 0.92rem;
    line-height: 24px;
    text-align: center;
    color: #5C7082 !important;
    margin-bottom: 0.5rem;
  }
`;

const IconContainer = styled.div`
    margin: 0 auto 24px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const Image = styled.img`
  height: 64px;
`;